/**
 * Created by sswaminathan on 1/24/22
 * File: UnClaimSubscriptionModal
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import {
  Body,
  Bold,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback, useMemo } from 'react'
import ZIndex from '../../../common/components/zIndex/ZIndex'
import { VIEW_MANAGE_TENANT } from '../../../common/constants/GlobalConstants'
import { selectTreeNode } from '../../../common/reducers/actions/TreeReducer.actions'
import { FF_MULTI_DLP } from '../../../common/utils/FeatureFlags'
import { getVarValue, setCurrentViewing } from '../../../common/utils/Sparky'
import { TENANT_CONTRACT_INFO, TENANTS } from '../constants/SubscriptionConstant'

const TenantInfoModal = ({ closeModal, title, content, row, value, isOpen, sgKeyBy, dispatch, ...rest }) => {
  const amendEnabled = getVarValue(FF_MULTI_DLP, false)
  const onClickHandler = useCallback((item, currentView) => {
    dispatch(selectTreeNode(sgKeyBy[item]))
    setCurrentViewing(currentView)
    closeModal()
  }, [closeModal, dispatch, sgKeyBy])

  const showTenantInfo = useMemo(() => {
    return (
      <div className='tw-flex tw-flex-col tw-p-2'>
        <Body addClassName='tw-mb-1' size='md'><Bold> {TENANT_CONTRACT_INFO}</Bold></Body>
        <Body size='md'>{row.original.contract}</Body>
        <Body addClassName='tw-mt-6 tw-mb-1' size='md'><Bold> {TENANTS}</Bold></Body>
        {value && value.map((item, index) => {
          const tsg_id = amendEnabled ? item?.tsg_id : item
          return <div key={index}
            className={`tw-flex tw-flex-row tw-border tw-border-indigo-500 tw-border-b-4 tw-pt-2 tw-gap-2 ${value?.length > 0 ? 'tw-cursor-pointer' : 'tw-cursor-auto'}`}
            onClick={onClickHandler.bind(this, tsg_id, VIEW_MANAGE_TENANT)}>
            <Body addClassName={'tw-text-blue-600 tw-truncate'}><Bold>{sgKeyBy[tsg_id]?.display_name}</Bold></Body>
          </div>
        })}
      </div>
    )
  }, [row.original.contract, value, amendEnabled, onClickHandler, sgKeyBy])

  return <ZIndex>
    <Modal style={{ top: '12%', height: '454px', width: '400px ' }}
      onClose={closeModal}
      isOpen={isOpen}
      confirmClose={false}
    >
      <div className='tw-flex tw-flex-col tw-h-full'>
        <ModalHeader title={title} />
        <ModalBody style={{ padding: '0px' }} >
          {showTenantInfo}
        </ModalBody>
        <ModalFooter style={{ marginTop: '80px', paddingTop: '15px' }}>
          <Button onClick={closeModal} >
            Close
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  </ZIndex>
}

TenantInfoModal.propTypes = {}
export default TenantInfoModal
